const basicAbilityRouter = {
  path: 'basic-ability',
  name: '',
  component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
  meta: { title: '' },
  children: [
    {
      path: 'admin-center',
      name: '',
      redirect: 'account-oauth/admin-center',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      meta: { title: '管理中心配置', path: '/docs/cloud/basic-ability/account-oauth/access-know' },
      children: [
        {
          path: 'create-app',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '应用创建', mdfilepath: '/appconfig/CreateThridPersionalApp.md' }
        },
        {
          path: 'apply-permission',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '权限申请', mdfilepath: '/appconfig/ApplyAbility.md' }
        },
        {
          path: 'basic-config',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '基本设置', mdfilepath: '/appconfig/BasicConfig.md' }
        }
      ]
    },
    {
      path: 'account-oauth',
      name: '',
      redirect: 'account-oauth/api-list',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      meta: { title: '使用WPS账号授权登录', path: '/docs/cloud/basic-ability/account-oauth/access-know' },
      children: [
        {
          path: 'api-list',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api列表', mdfilepath: '/basicability/accountoauth/WpsLogin.md', aimtilelist: ['IP白名单', '域名白名单', '授权说明', '接口目录'] }
        },
        {
          path: 'cplug-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'C插件接入', mdfilepath: '/basicability/accountoauth/CPlugAccess.md', aimtilelist: ['SDK说明', '资源下载', '接入须知'] }
        },
        {
          path: 'java-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Java版接入', mdfilepath: '/basicability/accountoauth/JavaAccess.md', aimtilelist: ['使用说明', 'SDK下载', 'SDK接口调用'] }
        },
        {
          path: 'go-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Go版接入', mdfilepath: '/basicability/accountoauth/GoAccess.md', aimtilelist: ['使用说明', 'SDK下载', 'SDK接口调用'] }
        },
        {
          path: 'python-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Python版接入', mdfilepath: '/basicability/accountoauth/PythonAccess.md', aimtilelist: ['使用说明', 'SDK下载', 'SDK接口调用'] }
        },
        {
          path: 'php-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Php版接入', mdfilepath: '/basicability/accountoauth/PhpAccess.md', aimtilelist: ['使用说明', 'SDK下载', 'SDK接口调用'] }
        },
        {
          path: 'js-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Js版接入', mdfilepath: '/basicability/accountoauth/JsAccess.md', aimtilelist: ['使用说明', 'SDK下载', 'SDK接口调用'] }
        }
      ]
    },
    {
      path: 'wps-pay',
      redirect: 'wps-pay/introduce',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      meta: { title: 'WPS支付', path: '/docs/cloud/basic-ability/wps-pay/access-know' },
      children: [
        {
          path: 'introduce',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '产品介绍', mdfilepath: '/basicability/wpspay/Introduce.md', aimtilelist: ['产品介绍', '在线演示', '产品流程', '接入说明'] }
        },
        {
          path: 'quick-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '快速接入', mdfilepath: '/basicability/wpspay/QuickAccess.md', aimtilelist: ['创建应用', '申请权限', '支付配置', '接口说明'] }
        },
        {
          path: 'api-list',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api列表', mdfilepath: '/basicability/wpspay/ApiList.md', aimtilelist: ['业务流程', '接口说明'] }
        },
        {
          path: 'h5-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'h5页面接入', mdfilepath: '/basicability/wpspay/H5Access.md', aimtilelist: ['接入须知', '接入方式', '页面支付地址', '支付回调'] }
        },
        {
          path: 'java-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Java版接入', mdfilepath: '/basicability/wpspay/JavaAccess.md', aimtilelist: ['接入须知', '资源下载', 'Demo试用', '应用开发'] }
        },
        {
          path: 'go-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Go版接入', mdfilepath: '/basicability/wpspay/GoAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'python-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Python版接入', mdfilepath: '/basicability/wpspay/PythonAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'php-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Php版接入', mdfilepath: '/basicability/wpspay/PhpAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'js-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Js版接入', mdfilepath: '/basicability/wpspay/JsAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        }
      ]
    },
    {
      path: 'app-oauth',
      name: '',
      redirect: 'app-oauth/api-list',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      meta: { title: '第三方应用授权' },
      children: [
        {
          path: 'api-list',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api列表', mdfilepath: '/basicability/appoauth/ApiList.md', aimtilelist: ['接口说明'] }
        },
        {
          path: 'signature',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api签名说明', mdfilepath: '/basicability/appoauth/Signature.md', aimtilelist: ['签名说明'] }
        },
        {
          path: 'oauth-change',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '授权地址变更', mdfilepath: '/basicability/appoauth/OauthChange.md', aimtilelist: ['授权变更说明'] }
        }
      ]
    }
  ]
}

export default basicAbilityRouter
